import React, { useState } from 'react';
import { TextField } from './TextField';
export function formatSsn(value: string): string {
  const d = value.replace(/\D/g, '').slice(0, 9);
  return [d.slice(0, 3), d.slice(3, 5), d.slice(5, 9)].filter(Boolean).join('-');
}
export function maskSsn(value: string): string {
  const d = value.replace(/\D/g, '');
  return d.length >= 4 ? `•••-••-${d.slice(-4)}` : '';
}
interface SsnFieldProps {
  value: string;
  onChange: (v: string) => void;
  error?: string;
}
export function SsnField({
  value,
  onChange,
  error
}: SsnFieldProps) {
  const [focused, setFocused] = useState(false);
  const digits = value.replace(/\D/g, '');
  return <TextField label="Social Security number" inputMode="numeric" autoComplete="off" placeholder="123-45-6789" value={focused || digits.length < 9 ? formatSsn(value) : maskSsn(value)} onFocus={() => setFocused(true)} onBlur={() => setFocused(false)} onChange={v => onChange(v.replace(/\D/g, '').slice(0, 9))} error={error} hint={error ? undefined : 'Encrypted and stored once. You won’t need to enter it again.'} data-id="element-712" data-mp="36w64o8kuo6z0" />;
}